import { useState } from 'react';
import { reportConfig } from '../config/report';

export default function ContactStep({ onSubmit, saving, error }) {
  const [form, setForm] = useState({
    firstName: '', businessName: '', email: '', phone: '',
    reportConsent: false, marketingConsent: false, website: ''
  });
  const update = (key, value) => setForm(current => ({ ...current, [key]: value }));

  return (
    <section className="contact-step" aria-labelledby="contact-title">
      <div className="question-kicker">YOUR PERSONALISED REPORT</div>
      <h1 id="contact-title">Where should we send your report?</h1>
      <p className="contact-intro">Your check-up is complete. Enter your details to see your personalised findings and cost estimate.</p>

      <form className="contact-form" onSubmit={event => { event.preventDefault(); onSubmit(form); }}>
        <div className="contact-field-grid">
          <div className="contact-field">
            <label htmlFor="bpa-first-name">First name <span className="field-required">*</span></label>
            <input id="bpa-first-name" name="firstName" required autoComplete="given-name" maxLength={80}
              value={form.firstName} onChange={e => update('firstName', e.target.value)} />
          </div>
          <div className="contact-field">
            <label htmlFor="bpa-business-name">Business name <span className="field-required">*</span></label>
            <input id="bpa-business-name" name="businessName" required autoComplete="organization" maxLength={150}
              value={form.businessName} onChange={e => update('businessName', e.target.value)} />
          </div>
          <div className="contact-field">
            <label htmlFor="bpa-email">Email <span className="field-required">*</span></label>
            <input id="bpa-email" name="email" required type="email" autoComplete="email" maxLength={254}
              value={form.email} onChange={e => update('email', e.target.value)} />
          </div>
          <div className="contact-field">
            <label htmlFor="bpa-phone">Mobile <span className="field-required">*</span></label>
            <input id="bpa-phone" name="phone" type="tel" required autoComplete="tel" maxLength={30}
              value={form.phone} onChange={e => update('phone', e.target.value)} />
          </div>
        </div>
        <div className="contact-trap" aria-hidden="true">
          <label htmlFor="bpa-website">Leave this field empty</label>
          <input id="bpa-website" name="website" tabIndex={-1} autoComplete="off"
            value={form.website} onChange={e => update('website', e.target.value)} />
        </div>
        <div className="contact-consents">
          <label className="contact-consent" htmlFor="bpa-report-consent">
            <input id="bpa-report-consent" type="checkbox" checked={form.reportConsent}
              onChange={e => update('reportConsent', e.target.checked)} />
            <span>Email me my report and related information from BPA Solutions (required only for email delivery).</span>
          </label>
          <label className="contact-consent" htmlFor="bpa-marketing-consent">
            <input id="bpa-marketing-consent" type="checkbox" checked={form.marketingConsent}
              onChange={e => update('marketingConsent', e.target.checked)} />
            <span>I agree to receive marketing and promotional messages from BPA Solutions by email or SMS. I can unsubscribe at any time with STOP or the unsubscribe link.</span>
          </label>
        </div>
        <p className="contact-policy"><a href={reportConfig.privacyUrl} target="_blank" rel="noopener noreferrer" >Privacy Policy</a></p>
        {error && <p role="alert" className="form-error">{error}</p>}
        <button disabled={saving} className="primary-button contact-submit" type="submit">
          {saving ? 'Preparing your report…' : 'Show my Health Report'}
        </button>
      </form>
    </section>
  );
}